import { DataGridListPage, DataGridActionMenu } from 'pages/Common';
import React, { useCallback, useMemo } from 'react';
import moment from 'moment';
import { MenuItem } from '@mui/material';
import { pageKeys } from 'store/reducers/dataGrid.reducer';
import { Link, useHistory } from 'react-router-dom';
import { Edit as EditIcon, DeleteForever as DeleteForeverIcon } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { deleteDataGridRow } from 'store/actions';
import apiEndpoints from 'constants/endpoints';


export const PremiumOrderList = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const onDelete = useCallback((orderId) => {
    const confirmed = window.confirm("Are you sure you want to delete this order permanently?");
    if (confirmed) {
      dispatch(deleteDataGridRow(apiEndpoints.orders, orderId, {}, {}, pageKeys.orderList));
    }
  }, [dispatch]);

  const columns = useMemo(() => {
    return [
      {
        field: 'orderRef',
        headerName: 'OrderRef',
        width: 300,
      },
      {
        headerName: 'User',
        cellRenderer: ({ data }) => <Link style={{textDecoration: "underline"}} to={`/users/${data.userId}`}>{data.firstName} {data.lastName}</Link>,
        width: 180,
      },
      {
        headerName: 'Plan',
        cellRenderer: ({ data }) => {
          if (data.eventId) {
            return <Link style={{textDecoration: "underline"}} to={`/events/${data.eventId}`}>Event {data.eventId}</Link>
          }
          return data.eventName || 'Premium Pass';
        },
        width: 180,
      },
      {
        field: 'startTime',
        headerName: 'Start Time',
        valueFormatter: ({ value }) => value && moment(value).format('L'),
        width: 120,
      },
      {
        field: 'endTime',
        headerName: 'End Time',
        valueFormatter: ({ value }) => value && moment(value).format('L'),
        width: 120,
      },
      {
        field: 'status',
        headerName: 'Status',
        width: 100,
      },
      {
        field: 'source',
        headerName: 'Source',
        width: 100,
        flex: 1,
      },

      {
        field: 'actions',
        headerName: 'Actions',
        width: 100,
        cellStyle: { textAlign: 'center' },
        headerClass: 'text-center',
        cellRenderer: ({ data }) => (
          <DataGridActionMenu>
            <MenuItem onClick={() => history.push(`/${apiEndpoints.orders}/${data.id}`)}><EditIcon />Edit</MenuItem>
            {data.source === 'admin' &&
            
            <MenuItem onClick={() => onDelete(data.id)}><DeleteForeverIcon />Remove</MenuItem>
            }
          </DataGridActionMenu>
        ),
      },
    ];
  }, [history, onDelete]);

  const filters = [
    {
      field: 'orderRef',
      label: 'Order Ref',
      type: 'search',
      value: null
    },
    {
      field: 'userId',
      label: 'User',
      type: 'user',
    },
    {
      field: 'source',
      label: 'Source',
      type: 'select',
      options: [
        {
          id: '',
          label: 'All'
        },
        {
          id: 'stripe',
          label: 'Stripe'
        },
        {
          id: 'pabbly',
          label: 'Pabbly'
        },
        {
          id: 'legacy',
          label: 'Legacy'
        },
        {
          id: 'admin',
          label: 'Admin'
        },
      ]
    },
  ];

  return <DataGridListPage
    columns={columns}
    filters={filters}
    apiEndpoint={apiEndpoints.orders}
    heading="Premium Orders"
    pageKey={pageKeys.orderList}
    onAdd={() => history.push(`/${apiEndpoints.orders}/new`)}
  />
}

